export enum STATUS_TYPE {
  DONE = 'DONE',
  ERROR = 'ERROR',
  NEW = 'NEW',
  PARTIAL = 'PARTIAL',
}
